import React from "react";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions/transition";
import { makeStyles } from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import classNames from "classnames";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiDialog-container": {
      justifyContent: "flex-end",
    },
  },
  paper: {
    width: "calc(100% - 15rem)",
  },
  actions: {
    justifyContent: "flex-start",
    padding: "1rem",
  },
  closeButton: {
    padding: ".75rem",
    marginLeft: "-1rem",
  },
}));

const Transition = React.forwardRef(function Transition(props: TransitionProps, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export type SlideoverProps = Omit<DialogProps, "keepMounter" | "fullScreen" | "maxWidth" | "TransitionComponent"> & {
  HeaderComponent?: React.ReactNode;
  FooterComponent?: React.ReactNode;
  onClose?: () => void;
};

const Slideover: React.FC<SlideoverProps> = ({
  className,
  HeaderComponent,
  FooterComponent,
  onClose,
  PaperProps,
  children,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Dialog
      className={classNames(classes.root, className)}
      PaperProps={{ className: classes.paper, ...PaperProps }}
      TransitionComponent={Transition}
      keepMounted
      fullScreen
      onClose={onClose}
      {...props}
    >
      <DialogTitle>
        <Grid container direction="column" spacing={2} wrap="nowrap">
          <Grid item>
            <IconButton data-testid="icon-button" onClick={onClose} color="secondary" className={classes.closeButton}>
              <CloseIcon />
            </IconButton>
          </Grid>
          {HeaderComponent && <Grid item>{HeaderComponent}</Grid>}
        </Grid>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      {FooterComponent && <DialogActions className={classes.actions}>{FooterComponent}</DialogActions>}
    </Dialog>
  );
};

export default Slideover;
